import moment from 'moment';
import { HttpClient } from '@/shared/lib/http-client';

export const updateTask = async ({ id, name = null, description = null, finishDate = null, status = null }) => {
  const response = await HttpClient.put(`/tasks/${id}`, {
    task_id: id,
    name: name,
    description: description,
    finish_date: finishDate ? moment(finishDate).format('DD-MM-YYYY') : null,
    status: status,
  });

  return response.data?.data;
};
